import script from "./AppModalSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppModalSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./AppModalSkeleton.vue?vue&type=style&index=0&id=4c69f072&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c69f072"]])

export default __exports__